import { render } from "./TramitesAvances.vue?vue&type=template&id=40a5be0a&scoped=true"
import script from "./TramitesAvances.vue?vue&type=script&lang=js"
export * from "./TramitesAvances.vue?vue&type=script&lang=js"

import "./TramitesAvances.vue?vue&type=style&index=0&id=40a5be0a&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\allikamay\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40a5be0a"]])

export default __exports__